import { render, staticRenderFns } from "./SuporteFeedbackModal.vue?vue&type=template&id=7650bcaa"
import script from "./SuporteFeedbackModal.vue?vue&type=script&lang=ts"
export * from "./SuporteFeedbackModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports